<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Create A Fundraiser</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Create a fundraiser for a champion</div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form modal-p2p-padding" [formGroup]="fundrasingForm">
    <div class="row">
        <div class="col-12">
            <mdb-form-control class="form-fill form-fill--p2p">
                <input
                    mdbInput
                    formControlName="displayName"
                    maxlength="128"
                    type="text"
                    data-name="displayName"
                    #displayName
                />
                <label mdbLabel (click)="onClickField(displayName)" [ngClass]="{'active': isDisplayNameInputLabelActive}" class="inputLabel">Fundraiser Name</label>
                @if(fundrasingForm.controls.displayName.hasError('required') && fundrasingForm.controls.displayName.touched) {
                    <span class="form-error ml-0">Invalid Name</span>
                }
            </mdb-form-control>
        </div>

        <div class="col-12">
            <mdb-form-control class="form-fill form-fill--p2p">
                <input
                    mdbInput
                    formControlName="name"
                    (ngModelChange)="searchDonor($event, 1); isAddActive = true"
                    [mdbAutocomplete]="autocompleteName"
                    maxlength="128"
                    (keydown.enter)="passOption($event)"
                    type="text"
                    data-name="name"
                    #name
                />
                <label mdbLabel (click)="onClickField(name)" [ngClass]="{'active': isNameInputLabelActive}" class="inputLabel">Donor Name</label>
                @if(fundrasingForm.controls.name.hasError('required') && fundrasingForm.controls.name.touched) {
                    <span class="form-error ml-0">Invalid Name</span>
                }
            </mdb-form-control>
            <mdb-autocomplete #autocompleteName="mdbAutocomplete" >
                @for(option of searchResult; track option.data.id) {
                    <mdb-option [value]="option.searchString" (click)="passOption($event)">
                        {{ option.searchString }}
                    </mdb-option>
                }
                @if(notFound) {
                    <div class="autocomplete-no-results d-none">No Results Found</div>
                }
            </mdb-autocomplete>
        </div>

        <div class="col-12">
            <mdb-form-control class="form-fill form-fill--p2p">
                <input
                    mdbInput
                    formControlName="email"
                    (ngModelChange)="searchDonor($event, 0); isAddActive = true"
                    [mdbAutocomplete]="autocompleteEmail"
                    (keydown.enter)="passOption($event)"
                    type="text"
                    data-name="email"
                    #email
                />
                <label mdbLabel (click)="onClickField(email)" [ngClass]="{'active': isEmailInputLabelActive}" class="inputLabel">Donor Email</label>
                @if(fundrasingForm.controls.email.invalid && fundrasingForm.controls.email.touched) {
                    <span class="form-error ml-0">Invalid Email</span>
                }
            </mdb-form-control>

            <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
                @for(option of searchResult; track option.data.id) {
                    <mdb-option [value]="option.searchString" (click)="passOption($event)">
                        {{ option.searchString }}
                    </mdb-option>
                }
                @if(notFound) {
                    <div class="autocomplete-no-results d-none">No Results Found</div>
                }
            </mdb-autocomplete>
        </div>



        <div class="col-12">
            <div class="form-fill form-fill--p2p">
                <input
                    currencyMask
                    formControlName="goal"
                    (ngModelChange)="isAddActive = true"
                    required
                    type="text"
                    class="active"
                >
                <label mdbLabel class="inputLabel active">Goal</label>
                @if(fundrasingForm.controls.goal.invalid && fundrasingForm.controls.goal.touched) {
                    <span class="form-fill-error--p2p ml-0">Goal must be more than $1</span>
                }
            </div>
        </div>

        @if(showTeams) {
            <div class="col-12">
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="teamId" class="mdb-select">
                        @for(team of campaignTypeData.teams; track team.id) {
                            <mdb-option [value]="team.id">{{team.name}}</mdb-option>
                        }
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Team Name</label>
                    @if(fundrasingForm.controls.teamId.invalid && fundrasingForm.controls.teamId.touched) {
                        <span class="form-fill-error ml-0">Team must be selected</span>
                    }
                </mdb-form-control>
            </div>
        }
        
        @if(campaignData.streetAddressRequired) {
            <div class="col-12">
                <h6 class="text-left">{{campaignData.streetAddressReason}}</h6>
                <mdb-form-control class="form-fill appGoogleMapsAutocomplete d-flex">
                    <app-mdb-input-google-maps-autocomplete
                        id="p2pAppGoogleMapsAutocomplete"
                        mdbInput
                        autocomplete="address"
                        label="Address"
                        class="d-flex w-100"
                        [formControl]="addressInput"
                    ></app-mdb-input-google-maps-autocomplete>
                </mdb-form-control>
                @if(addressInput.invalid && addressInput.touched) {
                    <div class="mt-n4">
                        <span class="form-error ml-0">
                            Street address required, Please select one or
                            <span (click)="openStreetAddressModal()" class="caption link-element">Enter Manually</span>
                        </span>
                    </div>
                }
            </div>
            <div class="col-12">
                <mdb-form-control class="form-fill">
                    <app-mdbp-input 
                        mdbInput 
                        formControlName="addressUnit" 
                        [showMaxLength]="false"
                        label='Unit/Apartment# (optional)'>
                    </app-mdbp-input>
                </mdb-form-control>
            </div>
        }
        @if(campaignData.phoneNumRequired) {
            <div class="col-12">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="phone" autocomplete="tel" type='tel' [showMaxLength]="false" phoneInputMask="on" label='Phone Number'></app-mdbp-input>
                    @if(fundrasingForm.controls.phone.touched && fundrasingForm.controls.phone.invalid) {
                        <span class="form-fill-error m-0">Please provide correct Number</span>
                    }
                </mdb-form-control>
            </div>
        }
        @if(campaignData.additionalInfoDesc) {
            <div class="col-12">
                <h6 class="text-left" [innerHTML]="campaignData.additionalInfoDetail"></h6>
                <mdb-form-control class="form-fill">
                    <app-mdbp-input 
                        mdbInput 
                        formControlName="addInfo" 
                        maxLength="512"
                        label= "{{campaignData.additionalInfoDesc}}">
                    </app-mdbp-input>
                    @if(fundrasingForm.controls.addInfo.invalid && fundrasingForm.controls.addInfo.touched) {
                        <span class="form-fill-error ml-0">Info required</span>
                    }
                </mdb-form-control>
            </div>
        }
    
        @if(campaignData.additionalInfoSelectDesc) {
            <div class="col-12">
                <h6 class="text-left">{{campaignData.additionalInfoSelectDesc}}</h6>
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="addInfoSelect" class="mdb-select">
                        @for(option of campaignData.additionalInfoSelect; track option.id) {
                            <mdb-option [value]="option">{{option}}</mdb-option>
                        }    
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select one</label>
                    @if(fundrasingForm.controls.addInfoSelect.invalid && fundrasingForm.controls.addInfoSelect.touched) {
                        <span class="form-fill-error ml-0">No option selected</span>
                    }
                </mdb-form-control>
            </div>
        }

        <div class="d-flex align-items-center col-12">
            <app-mdb-switch label="Send fundraiser creation email" formControlName="sendNotification"></app-mdb-switch>
            <div class="d-flex align-items-center ml-2 h-100">
                <app-text-popover
                    placement="right"
                    type="content"                       
                    title=""
                    text="Let the champion know that their fundraiser has been created via email"
                >
                </app-text-popover>
            </div>
        </div>
    </div>

</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" [ngClass]="{'disabled': !isAddActive}"
     (click)="addFundrasing()">Add</a>
</div>